// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__2Tc5A","paramInput":"JobSimulator_paramInput__278zh","input":"JobSimulator_input__2KZ0q"};